import DelaysManager from "../../pages/delays/manager";
import DelaysParetoReport from "../../pages/delays/pareto";
import DelaysReport from "../../pages/delays/report";

export const routeDelaysManager = "/delays/manager";
export const routeDelaysReport = "/delays/report";
export const routeDelaysPareto = "/delays/pareto";

export const delayRoutes = [
	{
		path: `${routeDelaysManager}`,
		element: <DelaysManager />,
	},
	{
		path: `${routeDelaysManager}/:shiftId`,
		element: <DelaysManager />,
	},
	{
		path: `${routeDelaysReport}`,
		element: <DelaysReport />,
	},
	{
		path: `${routeDelaysPareto}`,
		element: <DelaysParetoReport />,
	},
];
